"use client";

import DefaultLayout from "@/components/layouts/DefaultLayout";
import useTranslation from "@/hooks/useTranslation";
import getHeadersLocale from "@/lib/actions/getHeadersLocale";
import { getTextDirection, LayoutDirection } from "@/utils/locale";
import { useEffect, useState } from "react";

export default function AuthLayout({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  const [layoutDir, setLayoutDir] = useState<LayoutDirection>("ltr");
  const { t } = useTranslation();

  useEffect(() => {
    const get = async () => {
      const requestLocale = await getHeadersLocale();
      const dir = getTextDirection(requestLocale);

      setLayoutDir(dir);
    };

    get();
  }, []);

  return (
    <DefaultLayout>
      <div className="w-full h-full max-w-sm mx-auto pt-12" dir={layoutDir}>
        <div className="text-center">
          <h1 className="text-4xl text-neutral-content text-yellow-900 dark:text-yellow-300 text-balance">
            {t["Learn whatever you need to"]}
          </h1>
        </div>
        <div className="mt-4 rounded-lg py-6">{children}</div>
        <div className="mt-16 text-center fixed bottom-4 left-0 w-full">
          <div className="opacity-40 font-dialog text-sm">
            {t["Not a High Five Academy member yet?"]}
          </div>
          <a
            href="//high-five.ai"
            className="mt-1 font-dialog font-medium text-sm inline-block px-6 py-2 text-black/80 bg-black/5 dark:bg-white/5 hover:bg-black/[7.5%] dark:hover:bg-white/[7.5%] active:bg-black/10 dark:active:bg-white/10 rounded-full"
          >
            {t["Learn more"]}
          </a>
        </div>
      </div>
    </DefaultLayout>
  );
}
